import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const TrialOpBalNet = createAsyncThunk(
  "TrialBalance/TrialOpBalNet",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/TrialOpBalNet`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const TrialClosing = createAsyncThunk(
  "TrialBalance/TrialClosing",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/TrialClosing`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const TrialTFormat = createAsyncThunk(
  "TrialBalance/TrialTFormat",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/TrialTFormat`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const TrialOpening = createAsyncThunk(
  "TrialBalance/TrialOpening",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/TrialOpening`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const TrialBalanceSlice = createSlice({
  name: "FAS",
  initialState: {
    TrialOpBalNetdata: null,
    TrialClosingdata: null,
    TrialTFormatdata: null,
    TrialOpeningdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    ClosingFas: (state) => {
      state.TrialClosingdata = "no";
    },
    OpBalNetFan: (state) => {
      state.TrialOpBalNetdata = "no";
    },
    Tforment: (state) => {
      state.TrialTFormatdata = "no";
    },
    OpeningFan: (state) => {
      state.TrialOpeningdata = "no";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(TrialOpBalNet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(TrialOpBalNet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.TrialOpBalNetdata = action.payload;
      })
      .addCase(TrialOpBalNet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(TrialClosing.pending, (state) => {
        state.status = "loading";
      })
      .addCase(TrialClosing.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.TrialClosingdata = action.payload;
      })
      .addCase(TrialClosing.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(TrialTFormat.pending, (state) => {
        state.status = "loading";
      })
      .addCase(TrialTFormat.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.TrialTFormatdata = action.payload;
      })
      .addCase(TrialTFormat.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(TrialOpening.pending, (state) => {
        state.status = "loading";
      })
      .addCase(TrialOpening.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.TrialOpeningdata = action.payload;
      })
      .addCase(TrialOpening.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { OpeningFan, Tforment, OpBalNetFan, ClosingFas } =
  TrialBalanceSlice.actions;

export default TrialBalanceSlice.reducer;
